module.exports = __webpack_public_path__ + "img/joey-pro.f54adbed.jpg";